import { render, staticRenderFns } from "./NewCaptain.vue?vue&type=template&id=07a7a8d0&scoped=true"
import script from "./NewCaptain.vue?vue&type=script&lang=js"
export * from "./NewCaptain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a7a8d0",
  null
  
)

export default component.exports